<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_salesPerson') || '业务开发'"
            prop="salesPersonCode"
          >
            <dict-select
              v-model="formData.salesPersonCode"
              url="/master/common/dict/baseUserSelect"
              :placeholder="
                $l('form_placeholder_salesPerson') || '请选择业务开发'
              "
              :selectedLabel.sync="formData.salesPersonName"
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_buyer') || '采购跟单'"
            prop="buyerCode"
          >
            <dict-select
              v-model="formData.buyerCode"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('form_placeholder_buyer') || '请选择采购跟单'"
              :selectedLabel.sync="formData.buyerName"
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_orderSource') || '订单来源'"
            prop="orderSource"
          >
            <dict-select
              v-model="formData.orderSource"
              url="/master/common/dict/biz"
              :body="{ dictType: 'orderSource' }"
              :placeholder="
                $l('form_placeholder_orderSource') || '请选择订单来源'
              "
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_takeOrderOrg') || '接单公司（乙方）'"
            prop="takeOrderOrgCode"
          >
            <dict-select
              v-model="formData.takeOrderOrgCode"
              url="/sys/common/dict/system"
              :body="{ dictType: 'takeOrderOrgCode' }"
              :placeholder="
                $l('form_placeholder_takeOrderOrgCode') ||
                  '请选择接单公司（乙方）'
              "
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_takeOrderType') || '订单类型'"
            prop="takeOrderType"
          >
            <dict-select
              v-model="formData.takeOrderType"
              url="/sys/common/dict/system"
              :body="{ dictType: 'takeOrderType' }"
              :placeholder="
                $l('form_placeholder_takeOrderType') || '请选择订单类型'
              "
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_purchaseDate') || '下单日期'"
            prop="purchaseDate"
          >
            <el-date-picker
              v-model="formData.purchaseDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="
                $l('form_placeholder_purchaseDate') || '请选择下单日期'
              "
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_importanceLevel') || '重要程度'"
            prop="importanceLevel"
          >
            <dict-select
              v-model="formData.importanceLevel"
              url="/master/common/dict/biz"
              :body="{ dictType: 'importanceLevel' }"
              :placeholder="
                $l('form_placeholder_importanceLevel') || '请选择重要程度'
              "
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_quotedMethod') || '报价方式'"
            prop="quotedMethod"
          >
            <dict-select
              v-model="formData.quotedMethod"
              url="/sys/common/dict/system"
              :body="{ dictType: 'quotedMethod' }"
              :placeholder="
                $l('form_placeholder_quotedMethod') || '请选择报价方式'
              "
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_totalQty') || '产品总数量'">
            <el-input v-model="formData.totalQty" clearable readonly />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_totalAmount') || '采购金额'">
            <el-input v-model="formData.totalAmount" clearable readonly />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_currencyUnit') || '货币单位'"
            prop="currencyUnit"
          >
            <dict-select
              v-model="formData.currencyUnit"
              url="/master/common/dict/biz"
              :body="{ dictType: 'currencyUnit' }"
              :placeholder="
                $l('form_placeholder_currencyUnit') || '请选择货币单位'
              "
              style="width: 100%"
              size="mini"
              filterable
              clearable
              :disabled="!!evgPurchaseCode"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_deliveryDate') || '首次交货日期'"
            prop="deliveryDate"
          >
            <el-date-picker
              v-model="formData.deliveryDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="
                $l('form_placeholder_deliveryDate') || '请选择首次交货日期'
              "
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_custName') || '客户'"
            prop="custCode"
          >
            <dict-select
              v-model="formData.custCode"
              url="/master/common/dict/customerSelect"
              :placeholder="$l('form_placeholder_custName') || '请选择客户'"
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_scm') || '执行工厂'"
            prop="scmCode"
          >
            <dict-select
              v-model="formData.scmCode"
              url="/master/common/dict/scmCooperated"
              :placeholder="$l('form_placeholder_scm') || '请选择执行工厂'"
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_factoryPaymentTerms') || '付款条件'"
            prop="factoryPaymentTerms"
          >
            <dict-select
              v-model="formData.factoryPaymentTerms"
              url="/master/common/dict/biz"
              :body="{ dictType: 'paymentTerms' }"
              :placeholder="
                $l('form_placeholder_factoryPaymentTerms') || '请选择付款条件'
              "
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_orderScm') || '名义工厂'"
            prop="orderScmCode"
          >
            <dict-select
              v-model="formData.orderScmCode"
              url="/master/common/dict/scmCooperated"
              :placeholder="$l('form_placeholder_orderScm') || '请选择名义工厂'"
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_settlementFactory') || '结算工厂'"
            prop="settlementFactory"
          >
            <dict-select
              v-model="formData.settlementFactory"
              url="/master/common/dict/scmCooperated"
              :placeholder="
                $l('form_placeholder_settlementFactory') || '请选择结算工厂'
              "
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="
              $l('form_label_importanceLevelDesc') || '订单前期开发情况说明'
            "
          >
            <el-input
              v-model="formData.importanceLevelDesc"
              :placeholder="
                $l('form_placeholder_importanceLevelDesc') ||
                  '请输入订单前期开发情况说明'
              "
              type="textarea"
              rows="4"
              maxlength="1000"
              show-word-limit
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$l('form_label_remark') || '订单备注'">
            <el-input
              v-model="formData.remark"
              :placeholder="$l('form_placeholder_remark') || '请输入订单备注'"
              type="textarea"
              rows="4"
              maxlength="1000"
              show-word-limit
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import dayjs from 'dayjs'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    evgPurchaseCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      formData: {
        salesPersonCode: '',
        salesPersonName: '',
        buyerCode: '',
        buyerName: '',
        purchaseDate: '',
        currencyUnit: '',
      },
      rules: {
        custCode: [
          {
            required: true,
            message: this.$l('form_placeholder_custName') || '请选择客户',
            trigger: 'change',
          },
        ],
        salesPersonCode: [
          {
            required: true,
            message:
              this.$l('form_placeholder_salesPerson') || '请选择业务开发',
            trigger: 'change',
          },
        ],
        buyerCode: [
          {
            required: true,
            message: this.$l('form_placeholder_buyer') || '请选择采购跟单',
            trigger: 'change',
          },
        ],
        orderSource: [
          {
            required: true,
            message:
              this.$l('form_placeholder_orderSource') || '请选择订单来源',
            trigger: 'change',
          },
        ],
        takeOrderOrgCode: [
          {
            required: true,
            message:
              this.$l('form_placeholder_takeOrderOrgCode') ||
              '请选择接单公司（乙方）',
            trigger: 'change',
          },
        ],
        takeOrderType: [
          {
            required: true,
            message:
              this.$l('form_placeholder_takeOrderType') || '请选择订单类型',
            trigger: 'change',
          },
        ],
        purchaseDate: [
          {
            required: true,
            message:
              this.$l('form_placeholder_purchaseDate') || '请选择下单日期',
            trigger: 'change',
          },
        ],
        deliveryDate: [
          {
            required: true,
            message:
              this.$l('form_placeholder_deliveryDate') || '请选择首次交货日期',
            trigger: 'change',
          },
        ],
        quotedMethod: [
          {
            required: true,
            message:
              this.$l('form_placeholder_quotedMethod') || '请选择报价方式',
            trigger: 'change',
          },
        ],
        importanceLevel: [
          {
            required: true,
            message:
              this.$l('form_placeholder_importanceLevel') || '请选择重要程度',
            trigger: 'change',
          },
        ],
        currencyUnit: [
          {
            required: true,
            message:
              this.$l('form_placeholder_currencyUnit') || '请选择货币单位',
            trigger: 'change',
          },
        ],
        scmCode: [
          {
            required: true,
            message: this.$l('form_placeholder_scm') || '请选择执行工厂',
            trigger: 'change',
          },
        ],
        factoryPaymentTerms: [
          {
            required: true,
            message:
              this.$l('form_placeholder_factoryPaymentTerms') ||
              '请选择付款条件',
            trigger: 'change',
          },
        ],
        orderScmCode: [
          {
            required: true,
            message: this.$l('form_placeholder_orderScm') || '请选择名义工厂',
            trigger: 'change',
          },
        ],
        settlementFactory: [
          {
            required: true,
            message:
              this.$l('form_placeholder_settlementFactory') || '请选择结算工厂',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    ...mapState('admin/user', { userInfo: 'info' }),
  },
  mounted() {
    this.init()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    init() {
      if (this.evgPurchaseCode) {
        this.getData()
        return
      }

      const { userCode, userName, userNameEn } = this.userInfo || {}
      this.formData.salesPersonCode = userCode || ''
      this.formData.salesPersonName = [userNameEn, userName]
        .filter(Boolean)
        .join('-')
      this.formData.buyerCode = userCode || ''
      this.formData.buyerName = [userNameEn, userName].filter(Boolean).join('-')
      this.formData.purchaseDate = dayjs().format('YYYY-MM-DD')
      this.formData.currencyUnit = 'CNY'
    },
    async getData() {
      const res = await this.$api
        .ecomEvgPurchaseDetailApi({ evgPurchaseCode: this.evgPurchaseCode })
        .catch(() => null)
      const data = res?.body || {}
      this.formData = { ...data }
      this.$emit('loaded', data)
    },
    async reload() {
      const res = await this.$api
        .ecomEvgPurchaseDetailApi({ evgPurchaseCode: this.evgPurchaseCode })
        .catch(() => null)
      const data = res?.body || {}
      const { totalQty, totalAmount } = data
      this.formData = { ...this.formData, totalQty, totalAmount }
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomEvgPurchaseSaveApi(this.formData)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status, body } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      if (this.evgPurchaseCode) {
        this.getData()
        return
      }

      const { evgPurchaseCode, evgPurchaseNo } = body
      this.$router.replace({
        name: 'ecom-evgBiz-evgPurchaseOrder-detail',
        params: { evgPurchaseCode, pageType: 'edit' },
        query: { evgPurchaseNo },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
.side-frame-danger {
  padding: 1px 5px;
  border-left: 3px solid $color-danger;
  height: 20px;
  margin-top: 3px;
}
</style>
